import JoinComponent from './join.vue'
export default JoinComponent
